import { render, staticRenderFns } from "./DirectionsCompletedProjectsBlock.vue?vue&type=template&id=7a9ab8bc&scoped=true&"
import script from "./DirectionsCompletedProjectsBlock.vue?vue&type=script&lang=js&"
export * from "./DirectionsCompletedProjectsBlock.vue?vue&type=script&lang=js&"
import style0 from "./DirectionsCompletedProjectsBlock.vue?vue&type=style&index=0&id=7a9ab8bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9ab8bc",
  null
  
)

export default component.exports